import {AfterViewInit, Directive, ElementRef, Input} from '@angular/core';
import {UserGuideService} from "@services/user-guide.service";
import {TranslateService} from '@ngx-translate/core';

@Directive({
  selector: '[appUserGuide]',
  standalone: true
})
export class UserGuideDirective implements AfterViewInit {

  @Input() guideTitle: string;
  @Input() guideText: string;
  @Input() guideClipPadding: number;
  @Input() guideId: string;
  @Input() guideStep: number;
  @Input() guideButtonCaption: string = 'Next';
  @Input() guideHideButtons: boolean;
  @Input() guideNextHandler: Function;

  constructor(
      private el: ElementRef,
      private userGuideService: UserGuideService,
      private translateService: TranslateService,
  ) {
  }

  ngAfterViewInit() {
    if (this.guideId) {
      this.userGuideService.register({
        guideId: this.guideId,
        steps: [{
          element: this.el.nativeElement,
          text: this.translateService.instant(this.guideText),
          title: this.translateService.instant(this.guideTitle),
          nextButtonHandler: this.guideNextHandler,
          nextButtonCaption: this.translateService.instant(this.guideButtonCaption),
          step: this.guideStep,
          padding: this.guideClipPadding,
          hideButtons: this.guideHideButtons,
        }],
      });
    }
  }
}
